import fetch from "auth/FetchInterceptor";

const permissionsService = {};

permissionsService.getPermissions = function (params = {}) {
	return fetch({
		url: "/v1/rest/all-user-permissions",
		method: "get",
		params,
	});
};

permissionsService.getUserPermission = function (params = {}) {
	return fetch({
		url: "/v1/rest/user-permission",
		method: "get",
		params,
	});
};

export default permissionsService;
